import { render, staticRenderFns } from "./PreviewInduction.vue?vue&type=template&id=5472582a&lang=pug&"
import script from "./PreviewInduction.vue?vue&type=script&lang=js&"
export * from "./PreviewInduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports